import EzController from 'controllers/ez-base-controller';
import { parseBoolean } from 'lib/helpers';
import EzUser from 'init/init-user';

export default class FreeLabelController extends EzController {
  // #region Types
  declare readonly element:HTMLElement;
  // #endregion

  connect() {
    if (EzUser.isPro) return;

    if (parseBoolean(this.element.dataset.pro) === true) return;

    // Move call to next microtask to wait for other controller to register
    // See https://github.com/hotwired/stimulus/issues/201#issuecomment-435285227
    // and https://stimulus.hotwired.dev/reference/lifecycle-callbacks#order-and-timing

    Promise.resolve().then(() => {
      this.element.dispatchEvent(new CustomEvent('free-label:on'));
    });
  }
}
